import axios from 'axios';
import qs from 'query-string';
const instance = axios.create();

const find = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/contracts?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    formattedCSVContracts: data.formattedCSVContracts,
    totPod: data.numberPod,
    totPdr: data.numberPdr,
  };
};

const findForExport = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/contracts/export?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    formattedCSVContracts: data.formattedCSVContracts,
  };
};

const findAllForAdmin = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/contracts/admin/all?${qs.stringify(
      query
    )}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    formattedCSVContracts: data.formattedCSVContracts,
    totPod: data.numberPod,
    totPdr: data.numberPdr,
  };
};

const findForExportAdminAll = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/contracts/export/admin/all?${qs.stringify(
      query
    )}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    formattedCSVContracts: data.formattedCSVContracts,
  };
};

const findForTotImport = async ({ newToken, query }) => {
  const response = await axios({
    method: 'post',
    url: `${process.env.REACT_APP_API_URL}/contracts/tot-import`,
    headers: {
      Authorization: newToken,
    },
    data: query,
  });

  if (response instanceof Error) {
    return { error: response };
  }

  return {
    data: response.data.sumContractValue,
    total: response.headers['x-total-count'],
  };
};

const findResume = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/contracts/resume?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return { data, total: headers['x-total-count'] };
};

const findRecurrencyResume = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${
      process.env.REACT_APP_API_URL
    }/contracts/recurrency-resume?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return { data, total: headers['x-total-count'] };
};

const findUserContracts = async ({ newToken, query, userId }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/contracts/${userId}?${qs.stringify(
      query
    )}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    totPod: data.numberPod,
    totPdr: data.numberPdr,
  };
};

const findUserRecurrentContracts = async ({ newToken, query, userId }) => {
  const { data, headers } = await instance.get(
    `${
      process.env.REACT_APP_API_URL
    }/contracts/${userId}/recurrent?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    totPod: data.numberPod,
    totPdr: data.numberPdr,
  };
};

const findForExportRecurring = async ({ newToken, query, userId }) => {
  const { data, headers } = await instance.get(
    `${
      process.env.REACT_APP_API_URL
    }/contracts/${userId}/recurrent/export?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.contracts,
    total: headers['x-total-count'],
    formattedCSVContracts: data.formattedCSVContracts,
  };
};

export const importContracts = async ({ newToken, file }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/import-contracts`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const importContractsPolis = async ({ newToken, file }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/import-contracts/polis`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const importIafPolis = async ({ newToken, file, profileId }) => {
  try {
    file.append('profileId', profileId);
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/import-iaf-polis`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const importContractsSwitch = async ({ newToken, file }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/import-contracts-switch`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const importContractsPaids = async ({ profileId, newToken, file }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/recurrent/import-contracts-paids/${profileId}`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const importContractsPaidsPolis = async ({
  profileId,
  newToken,
  file,
}) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/recurrent/import-contracts-paids-polis/${profileId}`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const uploadDocumentForRecurrency = async ({ contractId, data, newToken }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/recurrent/document/${contractId}`,
      data,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteRecurringFeeFile = async ({ contractId, key, newToken }) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/contracts/recurrent/document/${contractId}`,
      data: {
        key
      },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const uploadDocumentForPartnerEon = async ({ contractId, data, newToken }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contracts/document/${contractId}`,
      data,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteFeeFile = async ({ contractId, key, newToken, isReport = false }) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/contracts/document/${contractId}`,
      data: {
        key,
        isReport,
      },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

const contractsAPIs = {
  find,
  findForExport,
  findForExportRecurring,
  findAllForAdmin,
  findForExportAdminAll,
  findUserContracts,
  findUserRecurrentContracts,
  importContracts,
  importContractsPolis,
  importIafPolis,
  findResume,
  findRecurrencyResume,
  findForTotImport,
  importContractsSwitch,
  importContractsPaids,
  importContractsPaidsPolis,
  uploadDocumentForRecurrency,
  deleteFeeFile,
};

export default contractsAPIs;
